define('OutSystems/ReactWidgets/Utils',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.KeyboardKey = exports.debounce = void 0;
    var debounce = function (callback, debounceDelay, immediate) {
        if (debounceDelay === void 0) { debounceDelay = 300; }
        if (immediate === void 0) { immediate = false; }
        var timeout;
        return function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (immediate && !timeout) {
                callback.apply(this, args);
            }
            if (typeof timeout === "number") {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                timeout = null;
                if (!immediate) {
                    callback.apply(_this, args);
                }
            }, debounceDelay);
        };
    };
    exports.debounce = debounce;
    var KeyboardKey;
    (function (KeyboardKey) {
        KeyboardKey["ENTER_KEY"] = "Enter";
        KeyboardKey["ESCAPE_KEY"] = "Escape";
        KeyboardKey["SPACE_KEY"] = " ";
    })(KeyboardKey || (exports.KeyboardKey = KeyboardKey = {}));
});
//# sourceMappingURL=Utils.js.map;
